module.exports = __webpack_public_path__ + "img/lg_ring_r_i_null_1@3x.9b2f1abe.png";